import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationIncidentsOriginsLaboratoriesCreateRequest,
    ConfigurationIncidentsOriginsLaboratoriesPatchInBatchRequest,
    ConfigurationIncidentsOriginsLaboratoriesResponse
} from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class IncidentsOriginsLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationIncidentsOriginsLaboratoriesResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationIncidentsOriginsLaboratoriesResponse>>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories`, filterModel, { params })
        return response.data
    }

    async getIncidentsOriginsLaboratoryById(laboratoryId: number, incidentsOriginsLaboratoryId: number): Promise<ConfigurationIncidentsOriginsLaboratoriesResponse> {
        const response = await axios.get<ConfigurationIncidentsOriginsLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories/${incidentsOriginsLaboratoryId}`)
        return response.data
    }

    async createIncidentsOriginsLaboratory(laboratoryId: number, request: ConfigurationIncidentsOriginsLaboratoriesCreateRequest): Promise<ConfigurationIncidentsOriginsLaboratoriesResponse> {
        const response = await axios.post<ConfigurationIncidentsOriginsLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories`, request)
        return response.data
    }

    async deleteIncidentsOriginsLaboratory(laboratoryId: number, incidentsOriginsLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories/batch`, { data: incidentsOriginsLaboratoryIds })
        return response.data
    }

    async patchIncidentsOriginsLaboratory(laboratoryId: number, requests: ConfigurationIncidentsOriginsLaboratoriesPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories/batch`, requests)
        return response.data
    }
}

export const incidentsOriginsLaboratoriesConfigurationServices = new IncidentsOriginsLaboratoriesConfigurationServices()
